module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/selected.fbbd7188.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/selected.png
// module id = 3077
// module chunks = 11